import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/Toast';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [state, setState] = useState({
    visible: false,
    message: '',
    type: 'info',
    actionLabel: null,
    actionTo: null
  });

  const showToast = useCallback((message, type = 'info', options = {}) => {
    setState({
      visible: true,
      message: String(message),
      type: type === 'success' || type === 'error' || type === 'info' ? type : 'info',
      actionLabel: options.actionLabel ?? null,
      actionTo: options.actionTo ?? null
    });
  }, []);

  const hideToast = useCallback(() => {
    setState(prev => ({ ...prev, visible: false }));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, hideToast }}>
      {children}
      <Toast
        visible={state.visible}
        message={state.message}
        type={state.type}
        onClose={hideToast}
        actionLabel={state.actionLabel || undefined}
        actionTo={state.actionTo || undefined}
        autoHideMs={state.type === 'error' ? 6000 : 4000}
      />
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
